import makeStyles from "@material-ui/core/styles/makeStyles";

const styles = makeStyles((theme) => ({
  label: {
    fontSize: 12,
    '&.disabled': {
      opacity: 0.5,
    }
  },
  icon: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    '&.disabled': {
      opacity: 0.5,
      cursor: 'initial',
    },
  },
  checkboxLabel: {
    fontFamily: 'Roboto-Regular'
  }
}));

export default styles;